import * as moment from "moment";
export const onboardingEmailId = "onboarding@myshubhlife.com";

export enum IncompleteInfoSubStatus {
    BS_6M_MISSING = "BANK_STATEMENT",
    BS_SALARY_MISSING = "BANK_STATEMENT",
    BS_NET_BANKING = "BANK_STATEMENT",
    BS_PDF_NET_AA = "BANK_STATEMENT",
    BS_NET_PDF = "BANK_STATEMENT",
    SELFIE_UNCLEAR = "SELFIE_UNCLEAR",
    PAN_UNCLEAR = "PAN_UNCLEAR",
    LATEST_PAYSLIP_MISSING = "OTHER_DOCS",
    WORK_EMAIL_MISMATCH = "PROFILE_UPDATE",
    WORK_ADDR_MISMATCH = "WORK_DETAILS",
    RESI_ADDR_MISMATCH = "RESIDENCE_ADDRESS",
    PERM_ADDR_INCOMPLETE = "PROFILE_UPDATE",
    RESI_ADDR_INCOMPLETE = "RESIDENCE_ADDRESS",
    WORK_ADDR_INCOMPLETE = "WORK_DETAILS",
    AADHAAR_OKYC = "AADHAAR_OKYC",
    BANK_DETAILS_INCOMPLETE = "LOAN_REQUEST",
    LOAN_REQUEST_INCOMPLETE = "LOAN_REQUEST",
    REFERENCES_INCOMPLETE = "REFERENCES",
    AADHAAR_UNCLEAR = "KYC",
    CURR_ADDR_PROOF_UNCLEAR = "KYC",
}

const incompleteInfoScreenMap = {
    BANK_STATEMENT: {
        heading: "Bank statement",
        message: `Please upload your salary account bank statement with latest 3 salary credits If you are unable to upload the statement, email us at ${onboardingEmailId}`,
        subStatuses: [],
    },
    WORK_DETAILS: {
        heading: "Work Information",
        message: "Work details you have provided is incomplete",
        subStatuses: [],
    },
    SELFIE_UNCLEAR: {
        heading: "Selfie",
        message: "Selfie image is unclear. Please upload a clear picture",
        subStatuses: [],
    },
    PAN_UNCLEAR: {
        heading: "Pan card",
        message: "Pan card image is unclear. Please upload a clear picture",
        subStatuses: [],
    },
    OTHER_DOCS: {
        heading: "Upload other documents",
        message: "Please upload other documents",
        subStatuses: [],
    },
    RESIDENCE_ADDRESS: {
        heading: "Residence address",
        message: "Residence address you have provided is not complete or mismatched",
        subStatuses: [],
    },
    AADHAAR_OKYC: {
        heading: "Aadhaar Okyc",
        message: "Aadhaar okyc for quick approval",
        subStatuses: [],
    },
    LOAN_REQUEST: {
        heading: "Loan related details",
        message: "You might have not completed your bank and loan details",
        subStatuses: [],
    },
    REFERENCES: {
        heading: "References Details",
        message: "You might have not completed your references details",
        subStatuses: [],
    },
    KYC: {
        heading: "Complete KYC",
        message: "Please complete kyc, OKYC or upload",
        subStatuses: [],
    },
};

export const getIncompleteInfoScreens = (subStatus: IncompleteInfoSubStatus[]) => {
    const relevantScreens = {};
    subStatus.forEach((status) => {
        if (IncompleteInfoSubStatus[status] && incompleteInfoScreenMap[IncompleteInfoSubStatus[status]]) {
            relevantScreens[IncompleteInfoSubStatus[status]] = {...incompleteInfoScreenMap[IncompleteInfoSubStatus[status]]};
            if (!relevantScreens[IncompleteInfoSubStatus[status]]["subStatuses"].includes(status)) {
                relevantScreens[IncompleteInfoSubStatus[status]]["subStatuses"].push(status);
            }
        }
    });
    return relevantScreens;
};

export const pageTitle = {
    bankStatement: "Bank statement",
    selfie: "Selfie capture",
    pan: "Pan upload",
    workDetails: "Work details",
    resiAddress: "Residence address",
    documents: "Document upload",
    loanRequest: "Loan details",
    references: "References",
    aadhaarOKYC: "Aadhaar OKYC",
};

export const maxPincodeLength = 6;

export const mobileNumberLength = 10;

export const dateToInputString = (date) => {
    return moment(date).format("YYYY-MM-DD");
};

export const convertDateToMilliseconds = (date: string) => {
    return date ? new Date(String(date)).getTime() : null;
};

export enum ScreenNames {
    BANK_STATEMENT= "BANK_STATEMENT",
    WORK_DETAILS = "WORK_DETAILS",
    SELFIE_UNCLEAR = "SELFIE_UNCLEAR",
    PAN_UNCLEAR = "PAN_UNCLEAR",
    OTHER_DOCS = "OTHER_DOCS",
    RESIDENCE_ADDRESS = "RESIDENCE_ADDRESS",
    LOAN_REQUEST = "LOAN_REQUEST",
    AADHAAR_OKYC = "AADHAAR_OKYC",
    REFERENCES = "REFERENCES",
    KYC = "KYC",
}

export enum MessageType {
    ERROR = "ERROR",
    SUCCESS = "SUCCESS",
}

export const removeExistingError = (err: {[key: string]: string}, fieldName: string) => {
    const {[fieldName]: removedValue, ...fieldErrors} = err;
    return {...fieldErrors};
};
